import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';
import StackedHorizontalBar from '../../insights/StackedHorizontalBar';

export const PleasantPercentage = ({ story, action, isPaused, config, storyData }) => {
    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            <h1 className={styles.size2} style={{ marginBottom: "4rem" }}>
                Overall your week felt...
            </h1>
            <h2 className={styles.pleasantnessPercentText} style={{ marginBottom: "0.7rem" }}>
                {storyData.data.pleasantPercentage}% Pleasant vs {storyData.data.unpleasantPercentage}% Unpleasant
            </h2>
            <StackedHorizontalBar greenPercentage={storyData.data.pleasantPercentage} redPercentage={storyData.data.unpleasantPercentage} />
            <p style={{ margin: "4rem 1rem 4rem" }}>
                {storyData.data.percentDiff ? storyData.data.percentDiff : ""}
            </p>
        </StoryWrapper>
    );
};